import React, { useState } from 'react'
// import { Pagination, Input, Message } from '@arco-design/web-react'
// import { Document, Page, pdfjs } from 'react-pdf'
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
// import { Viewer } from '@react-pdf-viewer/core'
// // Plugins
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
// // 语言
// import { localeSwitcherPlugin } from '@react-pdf-viewer/locale-switcher'
// import { LocaleIcon } from '@react-pdf-viewer/locale-switcher'
// // Import styles
// import '@react-pdf-viewer/core/lib/styles/index.css'
// import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import './style/index.less'

// pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

interface Props {
  url: string
}

const ReactPdf = (props: Props) => {
  const { url } = props

  // Create new plugin instance
  // const defaultLayoutPluginInstance = defaultLayoutPlugin()
  // const localeSwitcherPluginInstance = localeSwitcherPlugin()

  return (
    <div className="outContent">
      {/* 方式一 */}
      {/* <Viewer
        fileUrl={url}
        plugins={[
          // Register plugins
          defaultLayoutPluginInstance,
          // localeSwitcherPluginInstance,
        ]}
      /> */}

      {/* 方式二 */}
      {/* <div>
        <div style={{ marginBottom: 4 }}>
          <a href={url} target={'_blank'} rel="noreferrer">
            查看当前文件
          </a>
        </div>

        <Document
          file={url}
          loading="加载中，请稍候..."
          error="加载预览文件失败"
          onLoadSuccess={onDocumentLoadSuccess}>
          {new Array(numPages).fill('').map((item, index) => (
            <Page
              className="mb24"
              scale={0.5}
              key={index}
              pageNumber={index + 1}
            />
          ))}
        </Document>
        <Pagination
          style={{ marginTop: 4, display: 'flex', justifyContent: 'flex-end' }}
          total={numPages}
          simple
          hideOnSinglePage
          showTotal={(total) => `共 ${total} 页`}
          current={pageNumber}
          pageSize={1}
          size="small"
          onChange={onChangePage}
        />
      </div> */}

      {/* 方式三 */}
      <iframe
        src={url}
        width={'100%'}
        height={'100%'}
        style={{ minHeight: '80vh' }}
      />
    </div>
  )
}

export default ReactPdf
